import React from 'react'

import RelationsCollection from "../../../model2/relation/collection"
import PopoverMenuHeader from "../../popover-menu/popover-menu/popover-menu-header"
import PopoverMenuSeparator from "../../popover-menu/popover-menu/popover-menu-separator"
import RelatedItemsPopoverRow from "./row"
import RelatedItemAddLink from "../common/add-link"
import {RelatedItemAddHandler} from "../common/add-menu"

export type RelatedItemsPopoverParams = {
    relations   : RelationsCollection
    canEdit     : boolean
    onAdd       : RelatedItemAddHandler
    onRemove?   : {(id: ID): void}
}

type Props = {
    menuParams  : RelatedItemsPopoverParams
    hidePopover : callback
}

// Related Items as a POPOVER, for the document surfaces -- they have no block or
// tab to host a list. It is a MENU (`ui5-popover-menu` + `.option` rows), which
// is where the whole look comes from, so nothing here sets css of its own.
//
// Nothing closes it for us: Popover tethers its content to the body, so a click
// on a row is neither the trigger's onClick nor an outside click. Both ways out
// (Add, onNavigate) therefore hide it by hand.
export default function RelatedItemsPopover(props: Props) {

    const {relations, canEdit, onAdd, onRemove} = props.menuParams

    const rows = relations.models

    // Empty: no title -- a heading over an empty box states the obvious -- a
    // line of copy instead.
    const hasRows = rows.length > 0

    // Add opens a menu of its own now, so this closes on the TYPE being picked,
    // not on the Add row being clicked -- closing on the click would unmount the
    // menu before it could be used.
    const onAddSelected: RelatedItemAddHandler = (entityType) => {
        props.hidePopover()
        onAdd(entityType)
    }

    return (
        <div className="ui5-popover-menu" style={{width: 320}}>

            {hasRows &&
                <PopoverMenuHeader title="Related items"/>}

            {_.map(rows, (relation) =>
                <RelatedItemsPopoverRow key        = {relation.id}
                                        relation   = {relation}
                                        onRemove   = {canEdit ? onRemove : undefined}
                                        onNavigate = {props.hidePopover}/>)}

            {/* Nothing linked yet -- say what the feature is for before offering
                the button, since an empty popover explains nothing on its own. */}
            {!hasRows &&
                <div className="ui5-txt-not-important-small lh-14em p-h-20 p-t-10 p-b-10">
                    Related items let you link tasks, projects and documents, and keep
                    track of them in one place.
                </div>}

            {canEdit &&
                <>
                    {hasRows && <PopoverMenuSeparator/>}

                    {/* `.option` for the row shell (height, 20px inset, hover);
                        the link itself brings the blue plus and the lighter
                        text, and lands under the row icons. */}
                    <RelatedItemAddLink className = "option"
                                        label    = "Add related item"
                                        onAdd    = {onAddSelected}/>
                </>}
        </div>
    )
}
